import React from 'react';
import LandingLayout, { DEMO_MAILTO, SUPPORT_EMAIL } from './LandingLayout';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <LandingLayout>
      <section className="landing-hero landing-hero-cream">
        <div className="landing-hero-grid">
          <div className="landing-hero-content">
            <h1>The farmers market that never closes</h1>
            <a href={DEMO_MAILTO} className="landing-btn-primary landing-btn-demo">
              Request a Demo
            </a>
          </div>
          <div className="landing-hero-visual">
            <img
              src="/images/solutions/f2h_storefront.png"
              alt="Farmers Marketspace storefront"
              className="landing-hero-storefront"
            />
          </div>
        </div>
      </section>

      <section className="landing-value-props">
        <div className="landing-container">
          <div className="landing-value-panel">
            <p className="landing-value-intro">
              Farmers Marketspace gives markets across the country a 24/7 storefront—so customers can find you anytime, and you can run it with far less hands-on effort.
            </p>
            <div className="landing-value-grid">
              <div className="landing-value-card">
                <div className="landing-value-icon">
                  <i className="fas fa-chart-line"></i>
                </div>
                <h3>Grow Market Sales &amp; Revenue</h3>
                <ul>
                  <li>More orders mean more sales for the farmers in your market.</li>
                  <li>A small fee on every sale creates a new revenue stream for the market.</li>
                  <li>Capture data to increase sales, predict demand, support farmers, and grow the market.</li>
                </ul>
              </div>
              <div className="landing-value-card">
                <div className="landing-value-icon">
                  <i className="fas fa-expand-arrows-alt"></i>
                </div>
                <h3>Scaling Markets of Every Size</h3>
                <ul>
                  <li>We support small markets working to grow into a sustainable operation.</li>
                  <li>We support large markets looking for new ways to expand.</li>
                  <li>Affordable startup cost makes it easier for any market to reach a larger audience.</li>
                  <li>The more you grow, the more you earn from a small fee on every sale.</li>
                </ul>
              </div>
              <div className="landing-value-card">
                <div className="landing-value-icon">
                  <i className="fas fa-check-square"></i>
                </div>
                <h3>Intuitive</h3>
                <ul>
                  <li>Our technology is easy to use from day one.</li>
                  <li>Farmers can connect with customers—and customers can connect with farmers.</li>
                  <li>Farmers can control their produce, manage inventory, create packing lists, and access sales data.</li>
                  <li>Market leaders can access farmer accounts, help farmers get started, and stay connected.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="landing-testimonial">
        <div className="landing-container">
          <p className="landing-testimonial-lead">
            Ready to see how Farmers Marketspace works for your market?
          </p>
          <a href={DEMO_MAILTO} className="landing-btn-primary landing-btn-large">
            Request a Demo
          </a>
        </div>
      </section>

      <section className="landing-contact" id="contact">
        <div className="landing-container landing-contact-centered">
          <h2>Contact Us</h2>
          <p className="landing-contact-intro">
            Have questions? We&apos;d love to hear from you. Reach out to schedule a demo or learn more about Farmers Marketspace.
          </p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="landing-contact-email">{SUPPORT_EMAIL}</a>
        </div>
      </section>
    </LandingLayout>
  );
};

export default LandingPage;
